import { PureComponent } from 'react';

export class SpotHorizontalRule extends PureComponent {
    render() {
        return <div className="spot-horizontal-rule" />;
    }
}
